import { RadioButtonGroup, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './OffersPicker.css';
import { IOffer } from '../../repositories/chats/entities/get_my_offers_for_selection/Offer';
import { ERequestApiStatus } from '../../types/appState';
import { OffersEmptyState } from '../OffersEmptyState';
import { OffersPickerSelectionItem } from '../OffersPickerSelectionItem';

const RADIO_OPTIONS = [
  {
    label: 'Сдаю',
    value: 'rent',
  },
  {
    label: 'Продаю',
    value: 'sale',
  },
];

interface IProps {
  currentType: string;
  isReachedLimit: boolean;
  selectedIds: Array<number>;
  offersList: IOffer[];
  offersSelectionStatus: ERequestApiStatus;
  pickerAreaRef: React.RefObject<HTMLDivElement | null>;
  targetObserverElementRef: React.RefObject<HTMLDivElement | null>;
  upperEmptyBlockHeight: number;
  startIndex: number;
  endIndex: number;
  downEmptyBlockHeight: number;
  handleSlicedList: () => void;
  handleOffersLoad: () => void;
  onSelect(value: IOffer): void;
  handleTypeChange(_: never, value: string): void;
}

export const OffersPicker = ({
  currentType,
  selectedIds,
  offersList,
  offersSelectionStatus,
  isReachedLimit,
  pickerAreaRef,
  upperEmptyBlockHeight,
  startIndex,
  endIndex,
  downEmptyBlockHeight,
  targetObserverElementRef,
  handleSlicedList,
  onSelect,
  handleOffersLoad,
  handleTypeChange,
}: IProps) => {
  const isLoading = offersSelectionStatus === ERequestApiStatus.Pending;

  return (
    <div data-name="OfferPicker" className={style['picker']}>
      <div className={style['radio']}>
        <RadioButtonGroup options={RADIO_OPTIONS} value={currentType} onChange={handleTypeChange} />
      </div>
      <div ref={pickerAreaRef} className={style['offers']} onScroll={handleSlicedList}>
        <div style={{ height: `${upperEmptyBlockHeight}px` }} />
        {offersList.slice(startIndex, endIndex + 1).map((offer, index) => (
          <OffersPickerSelectionItem
            key={offer.realtyOfferId}
            offer={offer}
            isFirstInList={!index}
            isReachedLimit={isReachedLimit}
            selectedIds={selectedIds}
            onSelect={onSelect}
          />
        ))}
        {isLoading && (
          <div className={style['loader']}>
            <Spinner size={16} />
          </div>
        )}
        <div style={{ height: `${downEmptyBlockHeight}px` }} />
        <div style={{ height: 2 }} ref={targetObserverElementRef} />
      </div>
      {!offersList.length && !isLoading && (
        <OffersEmptyState onLoad={handleOffersLoad} isWithError={offersSelectionStatus === ERequestApiStatus.Failed} />
      )}
    </div>
  );
};
